export const IntegrationSummaryAnalyticsActionTypes = {
    API_RESPONSE_SUCCESS: '@@integration-summary-analytics/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@integration-summary-analytics/API_RESPONSE_ERROR',
    GET_SHIPMENTS_COUNT: '@@integration-summary-analytics/GET_SHIPMENTS_COUNT',
    GET_SHIPMENT_RATES_COUNT: '@@integration-summary-analytics/GET_SHIPMENT_RATES_COUNT',
    GET_ADJUSTMENTS_COUNT: '@@integration-summary-analytics/GET_ADJUSTMENTS_COUNT',
    GET_SHIPMENTS_WITH_RATES_COUNT: '@@integration-summary-analytics/GET_SHIPMENTS_WITH_RATES_COUNT',
    GET_SHIPMENTS_WITH_NO_RATES_COUNT: '@@integration-summary-analytics/GET_SHIPMENTS_WITH_NO_RATES_COUNT',
    GET_SURCHARGES_COUNT: '@@integration-summary-analytics/GET_SURCHARGES_COUNT',
    GET_NON_ZERO_SURCHARGES_COUNT: '@@integration-summary-analytics/GET_NON_ZERO_SURCHARGES_COUNT',
    GET_INTEGRATION_SUMMARY: '@@integration-summary-analytics/GET_INTEGRATION_SUMMARY',
};
